import React from 'react'
import { Route as ReactRoute, RouteProps } from 'react-router-dom'
import { RouterPath } from '@coachmate/router'

type Props = Omit<RouteProps, 'path'> & {
  path?: RouterPath
}

export const Route = (props: Props) => <ReactRoute {...props} />
